<template>
  <div class="option-drop-down-holder">
    <!--    <div class="num-label">pipe</div>-->
    <div class="drop-down-selected" v-if="getSelected" @click="handleDropDown">
      {{ getSelected.desc }}
      <div class="dd-arrow" :style="handleRotate" v-show="getIsPrint">
        <img :src="require('@/assets/svg/SVG/dd.svg')" />
      </div>
    </div>
    <div class="drop-down-options" ref="options" v-show="optionsVisible" @mousedown="handleOptionsDown">
      <div class="pipe-option-banner">Company Pipes</div>
      <Option v-for="(option, index) in unPromotedOptions" :key="index" :option="option"
        @click="handleOptionClick(option)" @mouseover="handleMouseHover(option)" />
      <div class="pipe-option-banner">Promoted Pipes</div>
      <Option v-for="(option, index) in promotedOptions" :key="index" :option="option"
        @click="handleOptionClick(option)" @mouseover="handleMouseHover(option)" />

    </div>
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';
import Option from '@/components/nelson/Option';
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';
import { useIdentityStore } from '@/store/IdentityStore';
import { usePrintStore } from '@/store/PrintStore';

export default {
  name: 'OptionDropDown',
  data () {
    return {
      visible: false,
    };
  },
  props: [
    'type',
    'segment'
  ],
  emits: [
    'overflow'
  ],
  components: {
    Option
  },
  computed: {
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    },
    optionsVisible () {
      return this.visible;
    },
    optionData () {
      // check roles for crud
      const identityStore = useIdentityStore();
      let user = identityStore.User.roles.includes('admin') ? true : false;
      const pipes = usePipeStore().getPipes;
      pipes.forEach((element) => {
        element.isHover = false;
        element.isUser = user;
      });
      return pipes;
    },
    promotedOptions () {
      const promotedPipes = this.optionData.filter((item) => item.isPromoted === true);
      return promotedPipes;
    },
    unPromotedOptions () {
      const unPromotedPipes = this.optionData.filter((item) => item.isPromoted === false);
      return unPromotedPipes;
    },
    getSelected () {
      const pipeStore = usePipeStore();
      if (pipeStore.getPipeById(this.$props.segment.id)) {
        return pipeStore.getPipeById(this.$props.segment.id);
      } else {
        return pipeStore.getPipes[0];
      }
    },
    handleRotate () {
      if (this.visible) {
        return { 'transform': 'rotate(180deg)' };
      }
    },
  },
  methods: {
    handleMouseHover (item) {
      this.optionData.forEach((element) => {
        element.isHover = false;
      });
      item.isHover = true;
    },
    handleDropDown () {
      this.visible = !this.visible;
      if (this.$props.type !== 'modal') {
      //  this.$refs.options.style.left =  this.$el.getBoundingClientRect().left + 'px';
      }
      setTimeout( () => {
        document.body.addEventListener('mousedown', this.handleClick);
      }, 500);
    },
    handleClick () {
      this.visible = false;
      document.body.removeEventListener('mousedown', this.handleClick);
    },
    handleOptionsDown (e) {
      e.stopImmediatePropagation();
    },
    handleOptionClick (option) {
      let segment = this.$props.segment;
      useSegmentStore().checkMatchingInletPipeTypes(segment, option);
      this.handleClick();
      useInputStore().sprinklerCalc();
    }
  }
};
</script>

<style scoped>
.option-drop-down-holder {
  display: flex;
  justify-content: flex-start;
  width: 100%;
/*  align-items: center;*/
  height: 100%;
  flex-direction: column;
  padding-left: 6px;
  padding-right: 6px;
  position: relative;
}
.drop-down-selected {
  white-space: nowrap;
  background-color: white;
  border-radius: 15px;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  padding-left: 10px;
/*  padding-right: 4px;*/
/*  height: 27px;*/
  cursor: pointer;
}
.num-label {
  font-size: 75%;
  color: #363636;
}
.dd-arrow {
  width: 18px;
  height: 18px;
  border-radius: 10px;
  background-color: darkgray;
  cursor:pointer;
}
.drop-down-options {
  width: 250px;
  max-height: 220px;
  background-color: white;
  border: 1px black solid;
  position: absolute;
  margin-top:25px;
  overflow-y: auto;
  z-index: 1000;
}
.drop-down-options-modal {
  max-height: 300px;
  background-color: white;
  border: 1px black solid;
  position: absolute;
  margin-top:50px;
}
.pipe-option-banner {
  background-color: #D3D3D3;
  font-weight: bold;
  padding-left: 5px;
}
</style>